import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { BaseService } from '../../../shared/services/base.service';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormMessageComponent } from '../../../components/form/message/message.component';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';

import { MedicalConditionModel } from '../../../models/master-data/medical-condition.model';
import { MedicalConditionService } from './medical-condition.service';
import { DialogService } from '../../../shared/services/dialog.service';

@Component({
    selector: 'modify-medical-condition-popup',
    templateUrl: 'modify-medical-condition-popup.component.html',
    providers: [MedicalConditionService]
})

export class ModifyMedicalConditionComponent implements OnInit {
    title: string;
    modifyMedicalConditionForm: FormGroup;
    medicalConditionModel = new MedicalConditionModel();
    formMessage = '';
    id: any;
    category: any;
    public isSuccess = false;

    constructor(
        private formBuilder: FormBuilder,
        private baseService: BaseService,
        public utility: Utility,
        private medicalConditionService: MedicalConditionService,
        public dialogRef: MdDialogRef<ModifyMedicalConditionComponent>,
        public dialogService: DialogService,
        @Inject(MD_DIALOG_DATA) public data: any) {
        this.createForm();
    }

    ngOnInit() {
        this.id = this.data.id;
        this.category = {
            id: this.data.categoryId,
            name: this.data.categoryName
        };

        if (this.id) {
            this.getMedical(this.id);
            this.title = 'Update Medical Condition';

        } else {
            this.InitAddMedical(this.category);
            this.title = 'Add New Medical Condition';
        }

    }

    createForm() {
        this.modifyMedicalConditionForm = this.formBuilder.group({
            name: ['', [Validators.required]],
            memo: '',
            categoryId: '',
            categoryName: ''
        });

    }

    close() {
        this.dialogRef.close(this.isSuccess);
    }

    getMedical(id) {
        this.medicalConditionService.getMedicalCondition(id).subscribe(
            (result) => {
                const data = result.json();
                this.medicalConditionModel = data;
                // this.medicalConditionModel.id = data['id'];
                // this.medicalConditionModel.medicalCondition = data['name'];
                // this.medicalConditionModel.memo = data['memo'];
                // this.medicalConditionModel.medicalConditionCategory = data['categoryName'];
                this.modifyMedicalConditionForm.controls['categoryId'] = data['categoryId'];
            }, (error) => { }
        );
    }

    InitAddMedical(category) {
        this.medicalConditionModel.categoryName = category.name;
        this.modifyMedicalConditionForm.controls['categoryId'].setValue(this.category.id);
    }

    addMedicalCondition() {
        this.medicalConditionService.addNewMedical(this.modifyMedicalConditionForm.value).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dialogService.openSuccessDialog({ message: data.message });
                    this.isSuccess = true;
                    this.close();
                }
            }
        )
    }

    editMedicalCondition() {
        this.medicalConditionService.updateMedical(this.data.id, this.modifyMedicalConditionForm.value).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dialogService.openSuccessDialog({ message: data.message });
                    this.isSuccess = true;
                    this.close();
                }
            }
        )
    }

    onSubmit() {
        if (this.modifyMedicalConditionForm.valid) {
            if (this.medicalConditionModel.id) {
                this.editMedicalCondition();
            } else {
                this.addMedicalCondition();
            }
        }
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/medical-condition/modify-medical-condition-popup.component.ts